export default "__VITE_ASSET__cb164a44__"